export const appRoutes = {
  home: '/',
  login: '/login',
  logout: '/logout',

  customers: '/customers',
  newCustomer: '/customers/new',
  customer: '/customers/:customer_id',
  customerTabFrameAgreement: '/customers/:customer_id/frame-agreement',
  customerTabAdmin: '/customers/:customer_id/admin',

  orders: '/orders',
  subscriptionOrders: '/orders/subscriptions',
  subscriptionOrder: '/orders/subscriptions/:order_id',
  deviceOrders: '/orders/devices',
  deviceOrder: '/orders/devices/:order_id',
  devicePolicyPrices: '/orders/devices/prices',
  ordersShop: '/orders/shop',
  ordersProducts: '/orders/products',

  creditCheck: '/credit-check',
  creditRequest: '/credit-request',
  creditRequestNewQuote: '/credit-request/new',
  creditCheckQuote: '/credit-check/:order_id',
  shopQuoteList: '/shop',
  shopQuote: '/shop/:order_id',
  shopOrders: '/shop/orders',
  shopOrder: '/orders/shop/:order_id',

  injuryReports: '/injury-reports',
  injuryReport: '/injury-reports/:id',

  tools: '/tools',
  whiteLabel: '/white-label',
  test: '/test',

  systemMessages: '/system-messages',

  tradeInOrders: '/trade-in',
  tradeInOrder: '/trade-in/:tradeInOrderId',

  salesSupport: '/sales-support',
  demoCustomer: '/sales-support/:id',
}
export const WAIVER_URL_OLD = 'skjema/auth/:code.pdf'
export const WAIVER_URL_NEW = 'form/:code/porting/authorization'

export const getFilteredList = (state, listSelector, ...filters) => {
  let list = listSelector(state)

  filters.forEach(filter => {
    list = filter(state, list)
  })

  return [...list]
}

export const applyTextFilter = (list, query, toString = elm => elm.toString()) => {
  if (!query) return list

  const keyWords = getRegexSafeString(query).split(' ')
  return list.filter(item =>
    keyWords.every(keyWord => {
      const regExp = new RegExp(keyWord, 'i')
      return getRegexSafeString(toString(item)).match(regExp)
    })
  )
}

export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

// eslint-disable-next-line
export const getRegexSafeString = string => string.replace(/([.?*+^$[\]\\(){}|])/g, '\\$1')

export const SORT_ORDER = {
  ASC: 'asc',
  DESC: 'desc',
}

export const isNullsy = value => value === undefined || value === null
